import { CssBaseline } from "@mui/material";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import React, { useEffect, useMemo, useState } from "react";
import darkTheme from "./darkTheme"; // Import dark theme
import lightTheme from "./lightTheme"; // Import light theme
import { useNavigate } from "react-router-dom";

const ThemeProvider = ({ children }) => {
  const [mode] = useState(
    localStorage.getItem("mode") === "dark" ? "dark" : "light"
  );

  // Toggle between light and dark themes
  const theme = useMemo(() => {
    return mode === "light" ? lightTheme : darkTheme;
  }, [mode]);

  return (
    <MUIThemeProvider theme={theme}>
      {/* <ThemeToggle toggleTheme={toggleTheme} mode={mode} /> */}
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
};

export default ThemeProvider;
